import React from 'react';

import Header from '../partials/Header';
import PrivacyContent from '../partials/PrivacyContent';
import Footer from '../partials/Footer';

function Research() {
  return (
    <div className="flex flex-col min-h-screen overflow-hidden">

      {/*  Site header */}
      <Header />

      {/*  Page content */}
      <main className="flex-grow">

        {/*  Page sections */}
        <PrivacyContent />

      </main>

      {/*  Site footer */}
      <Footer />

    </div>
  );
}

export default Research;